// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"498":"19e6f1e4","747":"15e71efa"}[chunkId] + ".chunk.css";
};